import styled from "styled-components";
import { HXPage } from "./HXDesktopPage";
export const AdminViewParent = styled(HXPage) ``;
